module.exports = __webpack_public_path__ + "img/22.a7dce78b.jpg";